import React from 'react'
import authorheaderStyle from './AuthorHeader.module.css'
import logo from '../../../assets/images/brandlogo.png'

export default function AuthorHeader() {
    return (
        <>
            <header className={authorheaderStyle.authorsHeader}>
                <div className={authorheaderStyle.authorsheaderContent}>
                    <div className='container'>
                        <nav className={`${authorheaderStyle.authorsnav} ${authorheaderStyle.authorsnavExpand} flex-wrap`}>
                            <div className={`${authorheaderStyle.authorsheaderLeft} me-auto`}>
                                <a href="https://www.authormeet.net/" >
                                    <div className={`${authorheaderStyle.authorsheaderBrand} d-flex align-items-start`}>
                                        <img src={logo} className="img-fluid" />
                                        <div className={authorheaderStyle.authorsbrandTitles}>
                                            <h6> AuthorMeet </h6>
                                            <p> Powered by: Bookworm Central </p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className={authorheaderStyle.authorsheaderRight}>
                                <div className={`${authorheaderStyle.authorsheaderbrandRight}  d-flex align-items-center`}>
                                    <div className={authorheaderStyle.auhtorsbrandRightIcon}>
                                        <img src={logo} className="img-fluid" />
                                    </div>
                                    <div className={authorheaderStyle.authorsTitleRight}>
                                        <h6>Author Username</h6>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </header>
        </>
    )
}
